import { useContext, useEffect, useState } from 'react';
import STORE from '../../../../store';
import AccountPickerContext from '../../../../contexts/AccountPickerContext';
import fiscalPeriodTypeCheckers from './fiscalPeriodTypeCheckers';

const useFiscalQuarters = () => {
  const { selectedAccountId } = useContext(AccountPickerContext);
  const [fiscalQuarters, setFiscalQuarters] = useState<
    FixedPeriods.FiscalQuarter[]
  >([]);

  useEffect(() => {
    STORE.fixedPeriods
      .getFixedPeriodIntervalsRef({
        fixedPeriodId: 'fiscalQuarters',
        accountId: selectedAccountId,
      })
      .onSnapshot((docs) => {
        const newFiscalQuarters: FixedPeriods.FiscalQuarter[] = [];
        docs.forEach((doc) => {
          const period = doc.data();

          if (fiscalPeriodTypeCheckers.isFiscalQuarter(period)) {
            newFiscalQuarters.push(period);
          }
        });
        setFiscalQuarters(newFiscalQuarters);
      });
  }, [selectedAccountId]);

  return { fiscalQuarters };
};

export default useFiscalQuarters;
